<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4 border-bottom">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear ruta de entrega</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Ruta</small>
                                <v-autocomplete v-model="data.route_id"
                                    :items="routes"
                                    :item-text="(row) => { return row.code + ' - ' + row.name; }"
                                    item-value="id"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.route_id ? 'is-invalid' : ''">
                                </v-autocomplete>
                                <small class="invalid-feedback" v-for="(error, index) in errors.route_id" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Chofer</small>
                                <v-autocomplete v-model="data.driver_id"
                                    :items="drivers"
                                    :item-text="(row) => { return row.type + ' - ' + row.name; }"
                                    item-value="id"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.driver_id ? 'is-invalid' : ''">
                                </v-autocomplete>
                                <small class="invalid-feedback" v-for="(error, index) in errors.driver_id" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Unidad</small>
                                <v-autocomplete v-model="data.unit_id"
                                    :items="units"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.unit_id ? 'is-invalid' : ''">
                                </v-autocomplete>
                                <small class="invalid-feedback" v-for="(error, index) in errors.unit_id" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <small class="input-title">Fecha</small>
                                <v-menu v-model="menu_date" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="data.date" v-bind="attrs" v-on="on"
                                            hide-details readonly clearable
                                            class="form-control form-control-sm"
                                            @click:clear="data.date = ''">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="data.date" no-title scrollable
                                        @input="menu_date = false">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            menu_date: false,
            data: {
                date: moment(new Date()).format('Y-M-D')
            },
            errors: {},
            count: 0,
            routes: [],
            drivers: [],
            units: [],
            id: this.$route.params.id,
        }
    },
    mounted() {
        this.ROUTES()
    },
    methods: {
        ROUTES: function(){
            axios({url: '/all/routes', method: 'GET' })
            .then((resp) => {
                this.routes = resp.data
            })
            .finally((resp)=>{
                this.DRIVERS()
            })
        },
        DRIVERS: function(){
            axios({url: '/is/drivers', method: 'GET' })
            .then((resp) => {
                this.drivers = resp.data
            })
            .finally((resp)=>{
                this.UNITS()
            })
        },
        UNITS: function(){
            axios({url: '/all/units', method: 'GET' })
            .then((resp) => {
                this.units = resp.data
            })
        },
        CREATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/deliver-routes', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'DeliverRouteIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        },
    },
}
</script>